@if (item) {
<!-- Main container -->
<nav class="level">
  <!-- Left side -->
  <div class="level-left">
    <div class="level-item">
      <h1 class="title is-2 has-text-weight-light" [title]="item.name">
        {{ item.name | truncate : ['70'] }}
      </h1>
      @if (item.status === Status.Pending) {
      <span class="tag is-warning ml-2">Pending</span>
      } @if (item.status === Status.Rejected) {
      <span class="tag is-danger ml-2">Rejected</span>
      } @if (item.status === Status.Published) {
      <span class="tag is-success ml-2"
        >Published since
        <strong class="has-text-light ml-2">{{
          item.publishedAt | date
        }}</strong></span
      >
      }
    </div>
  </div>

  <!-- Right side -->
  <div class="level-right">
    <p class="level-item">
      <a class="button is-danger is-outlined" [caseAction]="deleteAction">
        <span class="icon is-small">
          <i aria-hidden="true" class="icon icon-delete"></i>
        </span>
        <span>Delete</span>
      </a>
    </p>
    <p class="level-item">
      <a class="button is-link" [routerLink]="['/tools/' + item.id + '/edit']">
        <span class="icon is-small">
          <i aria-hidden="true" class="icon icon-edit"></i>
        </span>
        <span> Edit </span>
      </a>
    </p>
    <p class="level-item">
      @if (item.status === Status.Pending) {
      <a class="button is-success" [caseAction]="publishAction">
        <span class="icon is-small">
          <i aria-hidden="true" class="icon icon-file-text"></i>
        </span>
        <span>Publish</span>
      </a>
      } @if (item.status === Status.Published || item.status ===
      Status.Rejected) {
      <a class="button is-warning" [caseAction]="pendingAction"
        >Switch to pending</a
      >
      }
    </p>
    @if (item.status === Status.Pending) {
    <p class="level-item">
      <a class="button is-danger" [caseAction]="rejectAction">
        <span class="icon is-small">
          <i aria-hidden="true" class="icon icon-file-text"></i>
        </span>
        <span>Reject</span>
      </a>
    </p>
    }
  </div>
</nav>

<app-change-history
  [item]="item"
  [entityType]="Entity.Tool"
  [itemRelations]="itemRelations"
  [ngClass]="{ 'is-block mb-4': item.status === Status.Rejected }"
></app-change-history>

@if (item.status === Status.Rejected) {
<article class="message is-danger">
  <div class="message-body has-background-dark has-text-light">
    <p><strong>This tool has been rejected</strong></p>

    @if (item.rejectReason) {
    <p>
      <i class="icon icon-file-text mr-2"></i>
      <span>{{ item.rejectReason }}</span>
    </p>
    }
  </div>
</article>
}
<div class="columns is-multiline">
  <div class="column is-8">
    <div class="card">
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p
              class="is-uppercase has-text-grey-darker has-text-weight-medium is-size-6"
            >
              Excerpt
            </p>
            <div class="is-size-6" [innerHTML]="item.excerpt"></div>
          </div>
          <div class="column is-12">
            <p
              class="is-uppercase has-text-grey-darker has-text-weight-medium is-size-6"
            >
              Description
            </p>
            <div class="content">
              <div class="is-size-6" [innerHTML]="item.content"></div>
            </div>
          </div>
          <div class="column is-12">
            <p
              class="is-uppercase has-text-grey-darker has-text-weight-medium is-size-6"
            >
              Duration
            </p>
            <div class="content">
              @if (this.item.duration) {
              <div class="is-size-6">
                {{ this.item.duration }}
              </div>
              } @else {
              <div class="is-size-6">-</div>
              }
            </div>
          </div>
        </div>
        <hr />
        <div class="columns is-multiline">
          <div class="column is-12">
            <table class="table is-narrow">
              <tbody>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Website:
                  </td>
                  @if (!item.websiteLink) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.websiteLink }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.websiteLink }}
                    </a>
                  </td>
                  }
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Slack:
                  </td>
                  @if (!item.slackLink) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.slackLink }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.slackLink }}
                    </a>
                  </td>
                  }
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Tool package:
                  </td>
                  @if (!item.toolPackage) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.toolPackage }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.toolPackage }}
                    </a>
                  </td>
                  }
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Github:
                  </td>
                  @if (!item.githubLink) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.githubLink }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.githubLink }}
                    </a>
                  </td>
                  }
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Github stars:
                  </td>
                  <td>{{ item.githubStars ?? '-' }}</td>
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Github forks:
                  </td>
                  <td>{{ item.githubForks ?? '-' }}</td>
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Gitlab:
                  </td>
                  @if (!item.gitlabLink) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.gitlabLink }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.gitlabLink }}
                    </a>
                  </td>
                  }
                </tr>
                <tr>
                  <td
                    class="pl-0 has-text-grey-darker has-text-weight-medium is-size-6"
                  >
                    Hugging face:
                  </td>
                  @if (!item.huggingFaceLink) {
                  <td>-</td>
                  } @else {
                  <td>
                    <a
                      href="{{ item.huggingFaceLink }}"
                      class="has-text-link is-underlined"
                      target="_blank"
                      >{{ item.huggingFaceLink }}
                    </a>
                  </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-6">
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="content">
              @for (toolRelation of toolRelations; track toolRelation.propName)
              { @if ( toolRelation.propName === 'objectives' ||
              toolRelation.propName === 'organisations' ) {
              <h4
                class="is-uppercase has-text-dark has-text-weight-medium mt-1 is-size-6"
              >
                {{ toolRelation.label }}
              </h4>

              @if (!item[toolRelation.propName].length) {
              <em>-</em>
              } @else {
              <ul>
                @for (relation of item[toolRelation.propName]; track relation.id
                || $index) {
                <li>
                  <span class="is-size-6">{{ relation.name }}</span>
                </li>
                }
              </ul>
              }
              <hr />
              } }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column is-4">
    <div class="card">
      <div class="card-content">
        <div class="content">
          @for (toolRelation of toolRelations; track toolRelation.propName) {
          @if ( toolRelation.propName !== 'objectives' && toolRelation.propName
          !== 'organisations' ) {
          <h4
            class="is-uppercase has-text-dark has-text-weight-medium mt-1 is-size-6"
          >
            {{ toolRelation.label }}
          </h4>
          @if (!item[toolRelation.propName].length) {
          <em>-</em>
          } @else {
          <ul>
            @for (relation of item[toolRelation.propName]; track relation.id ||
            $index) {
            <li>
              <span class="is-size-6">{{ relation.name }}</span>
            </li>
            }
          </ul>
          }
          <hr />
          } }

          <h4
            class="is-uppercase has-text-dark has-text-weight-medium mt-1 is-size-6"
          >
            Is it a HAIP Related Tool?
          </h4>
          <div class="is-size-6">
            {{ item.isHAIPRelated ? 'Yes' : 'No' }}
          </div>
        </div>
      </div>
    </div>
    @if (item.image) {
    <div class="card mt-6">
      <div class="card-content">
        <h4
          class="is-uppercase has-text-dark has-text-weight-medium mt-1 is-size-6"
        >
          Image
        </h4>
        <div class="card-image">
          <case-image [path]="item.image" size="videoCard"></case-image>
        </div>
      </div>
    </div>
    }
    <div class="card mt-6">
      <div class="card-content">
        <div class="content">
          <h4
            class="is-uppercase has-text-dark has-text-weight-medium mt-1 is-size-6"
          >
            Submitter
          </h4>

          <div>
            <div class="is-flex is-align-items-center mb-2">
              <div class="avatar avatar-sm">
                <img
                  src="https://picsum.photos/id/177/64/64"
                  title="Submitter"
                  alt="image"
                />
              </div>
              <div
                class="is-flex is-flex-direction-column is-align-items-flex-start pl-2"
              >
                <span>{{ item.submitter }}</span
                ><strong>{{ item.email }} - {{ item.relationWithTool }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
